import React from 'react';
import UrgencyLabel from 'ats/pages/pipeline/components/UrgencyLabel';
import { jobPositionStore } from 'ats/pages/job-positions/JobPositionStore';
import PendingTaskBadge from 'ats/components/pending-task-badge/PendingTaskBadge';

export default function JobPositionCard({ job, onClick, isActive }) {
	const getPriority = value => {
		return jobPositionStore.priorityOptions.find(
			priority => priority.value === value
		);
	};

	const getUrgency = value => {
		return jobPositionStore.urgencyOptions.find(
			urgency => urgency.value === value
		);
	};

	const getStatus = value => {
		return jobPositionStore.statusOptions.find(
			status => status.value === value
		);
	};

	return (
		<div
			className={`job-position-card ${isActive ? 'is-active' : ''}`}
			onClick={() => onClick(job)}>
			<PendingTaskBadge count={job.pendingTasksCount} variant="count" />
			<div className="job-position-card-header">
				<UrgencyLabel
					mode="icon"
					value={job.urgency}
					text={getUrgency(job.urgency).text}
				/>
				<div
					data-tooltip={`Priority: ${getPriority(job.priority).text}`}
					className={`job-position-priority priority-${job.priority} tooltip is-tooltip-right`}>
					{getPriority(job.priority).text}{' '}
				</div>
				<span className="client-name">{job.client?.name || '--'}</span>
			</div>
			<div className="job-position-card-details">
				<span>#{job.id}</span>
				<span className="job-title">{job.title}</span>
				<span className={`status-tag status-${job.status}`}>
					{getStatus(job.status).text}
				</span>
			</div>
		</div>
	);
}
